import {
  GET_THREE_SHAPE_AUTH_URL,
  GET_THREE_SHAPE_END_SESSION_URL,
  GET_THREE_SHAPE_CASES,
  GET_THREE_SHAPE_CASE_FILES_DOWNLOAD_LINK,
  EXPORT_THREE_SHAPE_SCANS,
  IS_THREE_SHAPE_SCANS_UPLOAD_COMPLETED
} from 'services/query/ThreeShape.queries';
import { UseQueryType } from 'types/hooks';
import {
  ThreeShapeUrlResponse,
  ThreeShapeCasesResponse,
  ThreeShapeCaseFilesDownloadLinkResponse
} from 'types/ThreeShape';

import { UseGraphQlMutation, UseGraphQlQuery } from './hooks';

export const useGetThreeShapeAuthUrl: UseQueryType<{
  getThreeShapeAuthUrl: ThreeShapeUrlResponse;
}> = (config) => {
  return UseGraphQlQuery(GET_THREE_SHAPE_AUTH_URL, config);
};

export const useGetThreeShapeEndSessionUrl: UseQueryType<{
  getThreeShapeEndSessionUrl: ThreeShapeUrlResponse;
}> = (config) => {
  return UseGraphQlQuery(GET_THREE_SHAPE_END_SESSION_URL, config);
};

export const useGetThreeShapeCases: UseQueryType<{
  getThreeShapeCases: ThreeShapeCasesResponse;
}> = (config) => {
  return UseGraphQlQuery(GET_THREE_SHAPE_CASES, config);
};

export const useGetThreeShapeCaseFilesDownloadLink: UseQueryType<{
  getThreeShapeCaseFilesDownloadLink: ThreeShapeCaseFilesDownloadLinkResponse;
}> = (config) => {
  return UseGraphQlQuery(GET_THREE_SHAPE_CASE_FILES_DOWNLOAD_LINK, config);
};

export const useExportThreeShapeScans = () => {
  return UseGraphQlMutation(EXPORT_THREE_SHAPE_SCANS);
};

export const useIsThreeShapeScansUploadCompleted: UseQueryType<{
  isThreeShapeScansUploadCompleted: boolean;
}> = (config) => {
  return UseGraphQlQuery(IS_THREE_SHAPE_SCANS_UPLOAD_COMPLETED, config);
};
